window.addEventListener('load', function() {
  document.querySelectorAll('.WineCarousel').forEach(carousel => {
    const items = carousel.querySelectorAll('.WineCarousel-item');
    let current = 0;

    const go = dir => {
      const currentItem = items[current];
      current = current + dir;
      if (current >= items.length) {
        current = 0;
      }
      if (current < 0) {
        current = items.length - 1;
      }
      const nextItem = items[current];
      currentItem.style.left = (-dir * 100) + '%';
      nextItem.hidden = true;
      nextItem.offsetWidth;
      nextItem.style.left = (dir * 100) + '%';
      nextItem.hidden = false;
      nextItem.offsetWidth;
      nextItem.style.left = 0;
    };

    if (carousel.querySelector('.WineCarousel-controls')) {
      carousel.querySelector('.WineCarousel-control--prev').addEventListener('click', () => go(-1));
      carousel.querySelector('.WineCarousel-control--next').addEventListener('click', () => go(1));
    }
  });

  const showcase = document.querySelector('.HomeWine .WineCarousel');
  if (showcase) {
    let paused = false;
    setInterval(() => {
      if (paused) return;
      showcase.querySelector('.WineCarousel-control--next').click();
    }, 4000);
    showcase.addEventListener('mouseenter', () => {
      paused = true;
    });
    showcase.addEventListener('mouseleave', () => {
      paused = false;
    });
  }
});
